export default __webpack_public_path__ + "static/media/InfoBlue.a321ffc9.svg";